export const SET_STEP_1 = "SET_STEP_1";
export const SET_STEP_2 = "SET_STEP_2";
